import { TDeviceDataTabValues } from './DataTab/types';
import { DeviceCreateAdvancedFormValues } from './AdvancedTab/types';

export type Tabs = 'data' | 'advanced';

export type TDeviceFormValues = {
    data: TDeviceDataTabValues;
    advanced: DeviceCreateAdvancedFormValues;
};

export type TDeviceDialogType = 'create' | 'edit' | 'editMultiple';

export const DEVICE_TYPES = [
    { id: 'telt:', name: 'XT2+', canSetPassword: true },
    { id: 'kingspan:wap:', name: 'WAP', canSetPassword: true },
    { id: 'aiut:wap:', name: 'WAPEX', canSetPassword: true },
    { id: 'wmc:', name: 'Watchman Pro', canSetPassword: true },
    { id: 'wmf:', name: 'Flo', canSetPassword: true },
    { id: 'wmr:', name: 'Radar', canSetPassword: false },
    { id: 'sensit:', name: 'SENSiT', canSetPassword: true },
    { id: 'tek811:', name: 'TEK811', canSetPassword: false },
    { id: 'other', name: 'Other', translate: true, canSetPassword: true },
].sort((a, b) => {
    if (a.id === 'other') return 1;
    if (b.id === 'other') return -1;
    return a.name.localeCompare(b.name);
});
